// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609171718/js/" + chunkId + "." + {"44":"7407aa32","225":"11ef6f84","481":"841db067","486":"32d0635f","770":"0f68c415"}[chunkId] + ".0.7032205280652054.chunk.js";
};